import React, { useState, useEffect, createContext } from 'react';
import moment from 'moment';
import LANGUAGES from './languageList';

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState({ name: 'en-us', rtl: false });

  const i18n = LANGUAGES[language.name].file();

  useEffect(() => {
    const local = JSON.parse(localStorage.getItem('lang'));
    if (local) {
      setLanguage({ ...local });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('lang', JSON.stringify(language));
    if (language.name === 'en-us') {
      language.rtl ? (document.body.style.direction = 'rtl') : (document.body.style.direction = 'ltr');
      moment.locale('en-us');
    } else {
      language.rtl ? (document.body.style.direction = 'rtl') : (document.body.style.direction = 'ltr');
      moment.locale(language.name, require(`moment/locale/${language.name}`));
    }
  }, [language]);

  return <LanguageContext.Provider value={{ i18n, setLanguage, language }}>{children}</LanguageContext.Provider>;
};

export default LanguageProvider;
